import React from 'react';

import { ReactComponent as PhotoFrameIcon } from '@assets/svg/ic-photoframe.svg';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  editEnabled?: boolean;
  onEditPhotos?: () => void;
}

const EmptyGalleryBlock: React.FC<IProps> = ({ editEnabled, onEditPhotos }) => {
  const { t } = useTranslation();

  const showEditBtn = editEnabled && !!onEditPhotos;

  return (
    <div className={style.noPhotosBlock}>
      <PhotoFrameIcon className={style.noPhotosIcon} />
      {showEditBtn && (
        <div className={style.textWrapper}>
          <div className={style.blockTitle}>{t('No photos yet')}</div>
          <span className={style.blockDescr}>
            {t('Upload photos to visually document the equipment’s technical details.')}
          </span>
          <Button type="secondary" text={t('Add photo')} onClick={onEditPhotos} />
        </div>
      )}
    </div>
  );
};

export default EmptyGalleryBlock;
